import React, { Component } from 'react';
import * as crypto from 'crypto';
import {Redirect} from 'react-router-dom';


const LOGIN_HASH = 'a26db0fbacabe145be73ffb10950652ff97eee133f6e60197133888a5ae595175caa8b0a220ae0c9ee0ab65172c9ef5c7abafff70cf113e52626bfaed6c5b6df';

class AuthService {
  static login(pass) {
    if(localStorage.token) {
      return Promise.resolve(true);
    }

    return AuthService.authenticate(pass)
      .then((result) => {
        if (result.authenticated) {
          localStorage.token = result.token;
        }
        return Promise.resolve(result.authenticated);
      });
  }

  static authenticate(pass) {
    const hash = crypto.createHmac('sha512', pass);
    hash.update('text');

    const value = hash.digest('hex');
    if (value === LOGIN_HASH) {
      return Promise.resolve({
        authenticated: true,
        token: Math.random().toString(36).substring(7)
      })
    } else {
      return Promise.resolve({
        authenticated: false,
      })
    }
  }
}

export class Login extends Component {

  constructor(props) {
    super(props);
    this.state = {
      error: false,
      password: '',
      redirect: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    AuthService.login(this.state.password)
      .then(result => {
        if (result) {
          this.setState({redirect: true});
        } else {
          this.setState({error: true});
        }
      });
  }

  handleChange(event) {
    this.setState({password: event.target.value});

  }

  render() {
    return (
      <div className="content">
        { this.state.redirect? <Redirect to={'/member/schedule'}/> : ''}
        <div className="login-desc-wrapper">
          <div className="clearfix">
            <div className='exclamation-mark'>
              <i className="fa fa-exclamation-triangle"/>
            </div>
            <div className="login-desc">
              このページの閲覧は、緑フラウエンコールのメンバーのみに制限されています。緑フラウエンコールメンバーは、下記にパスワードを入力して下さい。
            </div>
          </div>
          { this.state.error ?
            <div className="error-msg">パスワードが間違っています</div> : ''}

          <form onSubmit={this.handleSubmit} className='login-form clearfix'>
            <input placeholder="password"
                   type='password'
                   name='password'
                   onChange={this.handleChange}/>
            <button type="submit">送信する</button>
          </form>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Login.jsx